import { post } from "../../helpers/api";

const state = {
  items: [],
  total: {},
  isLoadingData: true,
  isBtnLoading: false,
  isBtnEditLoading: false,
  search: "",
  isShowResultDialog: false,
  resultMsg: "",
  isSuccess: false,
};

function normalizeReportPayload(payload) {
  if (Array.isArray(payload)) {
    return {
      items: Array.isArray(payload[0]) ? payload[0] : [],
      total: payload[1] || {},
    };
  }

  if (payload && typeof payload === "object") {
    const items = payload.items || payload.data || payload.rows || payload.result || [];
    const total = payload.total || payload.summary || payload.totals || {};
    return {
      items: Array.isArray(items) ? items : [],
      total: total && typeof total === "object" ? total : {},
    };
  }

  return { items: [], total: {} };
}

const mutations = {
  SET_ITEMS(state, payload) {
    const normalized = normalizeReportPayload(payload);
    state.items = normalized.items;
    state.total = normalized.total;
    state.isLoadingData = false;
  },
  SET_IS_BTN_LOADING(state, isBtnLoading) {
    state.isBtnLoading = isBtnLoading;
  },

  REMOVE_ITEM(state, id) {
    state.items = state.items.filter((item) => {
      return item.no_id !== id;
    });
  },
  SET_SEARCH(state, search) {
    state.search = search;
  },
  SET_DELETE_SUCCESS(state, value) {
    state.isShowResultDialog = value.state;
    state.resultMsg = value.msg;
    state.isSuccess = value.isSuccess;
  },
};

const actions = {
  async getItems({ commit }, payload) {
    try {
      return post("item/get-report", payload, {
        id: 26,
        action: "view",
      })
        .then((response) => {
          commit("SET_ITEMS", response.data);
          commit("SET_IS_BTN_LOADING", false);
          commit("SET_IS_BTN_EDIT_LOADING", false);
          return response.data;
        })
        .catch((error) => {
          if (error.response.status == 408) {
            window.location.href = "/404";
          }
          return error;
        });
    } catch (error) {
      console.log(error);
    }
  },
};

const getters = {
  filterItems(state) {
    function deepSearch(obj, searchValue) {
      for (const key in obj) {
        const value = obj[key];

        if (value !== null && typeof value === "object") {
          if (deepSearch(value, searchValue)) {
            return true;
          }
        } else if (
          value != null &&
          value.toString().toLowerCase().includes(searchValue.toLowerCase())
        ) {
          return true;
        }
      }
      return false;
    }

    return state.items.filter((item) => {
      return deepSearch(item, state.search.toLowerCase());
    });
  },
  getResultDialog: (state) => state.isShowResultDialog,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
